import React, {useState, useEffect} from 'react';
import {ChainSorter} from 'chainsorter';
import Filterable from '../components/ui/filter/Filterable.js';
import EmployeeForm from '../components/employee/interface.js';
import EmployeeSummary from '../components/employee/summary.js';
import Box from '../components/ui/Box.js';

import api from '../api/index.js';

import './Employees.scss';

const TableWrap = (props) => {
	return <table className="data-table">
				<thead>
					<tr>
						<th className="name">Name</th>
						<th className="wage">Wage</th>
					</tr>
				</thead>
				<tbody>
				{props.children}
				</tbody>
			</table>;
}


const EmployeesPage = (props) => {
	
	const [children, setChildren] = useState([]);
	const [loaded, setLoaded] = useState(false);
	const [currentChild, setCurrentChild] = useState(null);
	const [interfaceOpen, setInterfaceOpen] = useState(false);
	
	
	const refresh = async () => {
		try {
			let data = await api.get('employees');
			data = data.map((a) => {
				a['discontinued'] = a.Visible !== 'Y';
				a['onClick'] = (e)=>selectChild(a);
				return a;
			});
			data = ChainSorter(data).custom((a,b) => {
				if (a.discontinued && !b.discontinued)
					return 1;
				if (!a.discontinued && b.discontinued)
					return -1;
				return 0;
			}).asc('FirstName', 'LastName').sort()
			setChildren(data);
			return data;
		} catch(e) {
			api.handleExceptions(e);
		};
	}
	
	
	useEffect(() => {
		if (loaded === false) {
			setLoaded(true);
			refresh();
		}
	});
	
	
	const selectChild = (data) => {
		console.log("selected", data);
		setCurrentChild(data);
		setInterfaceOpen(true);
	}
	
	const onAddSubmit = (e) => {
		// An employee has been added, refresh the data
		(async function() {
			const all = await refresh();
			console.log("currentChild being set to", e);
			let u = false;
			console.log(all);
			for(var i=0; i < all.length; i++) {
				if (all[i]['EmployeeID'] == e['EmployeeID']) {
					u = all[i];
					break;
				}
			}
			if (u !== false) {
				setCurrentChild(u);
				setInterfaceOpen(true);
			}
		})();
		return true;
	}
	
	const onUpdated = (e) => {
		refresh();
		setInterfaceOpen(false);
	}

	// This is for when the wage changes so we want to keep the interface open
	const onSoftUpdate = (e) => {
		(async function() {
			const data = await refresh();
			for(let i=0; i < data.length; i++) {
				if (data[i]['EmployeeID'] == currentChild['EmployeeID']) {
					setCurrentChild(data[i]);
					break;
				}
			}
		}())
	}
	
	return <div className="employees-page">
		<h2>Employees</h2>
		<Filterable 
			summaryComponent={EmployeeSummary}
			addForm={EmployeeForm}
			onAddSubmit={onAddSubmit}
			filter={null}
			children={children}
			wrapper={TableWrap}
			onSelect={selectChild}
			onClick={selectChild}
			type="employee"
			
		/>
		<Box 
			modal={true}
			isOpen={interfaceOpen}
			onRequestClose={()=>setInterfaceOpen(false)}
			title={currentChild ? "Update: " + currentChild.FirstName + " " + currentChild.LastName : "No employee selected"}
		>
			<EmployeeForm {...currentChild} onUpdated={onUpdated} onSoftUpdated={onSoftUpdate} onDelete={onUpdated} />
		</Box>
	</div>;
}
export default EmployeesPage;